import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BLOGS } from "../../constants/BlogConstant";
import { getBlogCategories } from "../../utils/blogUtils";

type CategoryProps = {
  selectedCategory?: string | null;
  handleFilterByCategory?: (category: string) => void;
};

const Category: React.FC<CategoryProps> = ({ selectedCategory, handleFilterByCategory }) => {
  const categories = getBlogCategories(BLOGS);
  const navigate = useNavigate();

  const handleClick = (name: string) => {
    if (handleFilterByCategory) {
      handleFilterByCategory(name);
    }
    navigate(`/blogs?category=${encodeURIComponent(name)}`);
  };

  return (
    <div className="single-widgets widget_egns_categoris">
      <div className="widget-title">
        <h4>Categories</h4>
      </div>
      <ul className="wp-block-categoris-cloud">
        {categories.map(({ name, count }) => (
          <li key={name}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleClick(name);
              }}
               className={selectedCategory === name ? "active" : ""}
              >
              <span>{name}</span>
              <span className="number-of-categoris"> {count} </span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Category;
